import { apiFetch } from "../api/fetcher";

type FetchOptions = {
  endpoint: string;
  method?: "GET" | "POST" | "PUT" | "DELETE";
  queryParams?: Record<string, string | number | boolean | any>;
  pathParams?: Record<string, string | number | any>;
  responseType?: "json" | "blob";
  body?: any;
  isUmUrl?: boolean,
  resourceName?: string;
};

export async function fetchApi({
  endpoint,
  method = "GET",
  queryParams,
  pathParams,
  responseType = "json",
  body,
  isUmUrl,
  resourceName
}: FetchOptions) {
  let url = endpoint;

  // Replace path variables (e.g. {tripId})
  if (pathParams) {
    Object.entries(pathParams).forEach(([key, value]) => {
      url = url.replace(
        `{${key}}`,
        encodeURIComponent(String(value))
      );
    });
  }

  // Append query params
  if (queryParams && Object.keys(queryParams).length > 0) {
    const query = new URLSearchParams(
      Object.entries(queryParams).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null) {
          acc[key] = String(value);
        }
        return acc;
      }, {} as Record<string, string>)
    ).toString();

    url += `?${query}`;
  }

  return apiFetch(url, { method, body: body ? JSON.stringify(body) : undefined }, responseType, isUmUrl, resourceName);
}
